import { ObjectDateTransformer } from '../../coaching-insight.model';
import {
    defaultInsightsSummaryDataKpi,
    InsightsSummaryDataKpi,
} from '../model/insights-summary-data-kpi.model';
import {
    defaultInsightsSummaryDataPeriodTypes,
    InsightsSummaryDataPeriodTypes,
} from '../model/insights-summary-data-period-types.model';
import { InsightsSummaryData } from '../model/insights-summary-data.model';
import { KpiType } from '../model/kpi-type.model';

import { checkKpiFormat } from './check-kpi-format.function';

export function checkInsightSummaryData(opts: {
    insightSummaryData: InsightsSummaryData;
    periodTypeId: number;
    periodDate: Date;
    kpiTypeId: KpiType;
}): {
    insightSummaryData: InsightsSummaryData;
    selectedPeriodType: InsightsSummaryDataPeriodTypes;
    selectedKpi: InsightsSummaryDataKpi;
} {
    const dateTransformer = new ObjectDateTransformer<InsightsSummaryData>({
        periodTypes: {
            periodTypeDate: null,
        },
    });

    const data = dateTransformer.transform(opts.insightSummaryData) || {};
    data.periodTypes = data.periodTypes || [];
    data.kpis = (data.kpis || []).sort(
        (a, b) => a.displayOrder - b.displayOrder,
    );

    let selectedPeriodType =
        data.periodTypes.find(
            (e) =>
                e.periodTypeId === opts.periodTypeId &&
                e.periodTypeDate.getTime() === opts.periodDate.getTime(),
        ) || data.periodTypes.find((e) => e.isDefault);
    if (selectedPeriodType == null && data.periodTypes.length !== 0) {
        selectedPeriodType = data.periodTypes[0];
    }
    if (selectedPeriodType == null) {
        selectedPeriodType = defaultInsightsSummaryDataPeriodTypes();
    }

    let selectedKpi =
        data.kpis.find((e) => e.kpiTypeId === opts.kpiTypeId) ||
        data.kpis.find((e) => e.isDefault);
    if (!selectedKpi && data.kpis.length !== 0) {
        selectedKpi = data.kpis[0];
    }
    if (selectedKpi == null) {
        selectedKpi = defaultInsightsSummaryDataKpi();
    }

    checkKpiFormat(data.kpis);

    return { insightSummaryData: data, selectedPeriodType, selectedKpi };
}
